<template>
  <div class="validator-status">
    <div class="overview">
      <div class="head">

        <div class="icon">
          <img src="../assets/eth.png" />
        </div>
        <div class="title">
          Staked ETH
        </div>

      </div>

      <div class="stake-info">
        <div class="amount">
          {{ totalStakedETHShow }}
        </div>
        <div class="btn" :class="{'btn-active': liquefyBtnActiveStatus == 1}" @click="liquefy">
          Liquify
        </div>
      </div>

      <div class="amount-detail">
        <div class="self-amount">
          Self-deposited: <span class="bold">{{ selfDepositedShow }}</span>
        </div>
        <div class="apr">
          Current APR: <span class="bold">{{ currentApr }}</span>
        </div>
      </div>
    </div>

    <div class="contract">
      <div class="contract-head">
        <div class="contract-title">
          Pool Contracts ({{ poolCount }})
        </div>
      </div>

      <div class="contract-items">
        <template 
            v-for="(item, index) in addressItems"  >
            <div class="contract-item" :key="index">
              <div class="address-desc">Address:</div>
              <div class="address" @click="jumpToPoolDetail(item)">{{ item.shortAddress }}</div>
              <div class="address-status">
                <template v-if="item.status == -1">
                  --
                </template>
                <template v-if="item.status == 8">
                  Dissolved
                </template>
                <template v-if="item.status == 7">
                  Waiting
                </template>
                <template v-if="item.status == 2">
                  Pending
                </template>
                <template v-if="item.status == 3">
                  Active
                </template>
                <template v-if="item.status == 4">
                  Exited
                </template>
                <template v-if="item.status == 5">
                  Exiting
                </template>
                <template v-if="item.status == 6">
                  Slashing
                </template>
              </div>
            </div>
          </template>
      </div>
    </div>

    <div class="deposit-btn" @click="newValidatorDeposit">
      New Deposit
    </div>

  </div>
</template>

<script>
import NumberUtil from '../util/numberUtil.js';
import StringUtil from '../util/stringUtil.js';
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Web3Util from '../util/web3Util.js';
import LocalStorage from '../util/localStorage.js';
import Rpc from '../util/rpc.js';

export default {
  name: 'validatorStatus',
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      totalStakedETH: 0,
      totalStakedETHShow: '0.000000',
      selfDeposited: 0,
      selfDepositedShow: '0.00',
      currentApr: '--',
      poolCount: 0,
      nodeDepositBalance: 0,
      userDepositBalance: 0,
      addressItems: [],
      pubKeys: [],
      pubKeyMap: new Map(),
      liquefyBtnActiveStatus: 0
    }
  },

  methods: {
    liquefy() {
      Toast({ 
        message: 'This feature is not yet open.', 
        duration: 3000 
      });
      // if (this.liquefyBtnActiveStatus == 0) {
      //   return;
      // }
      // this.$router.push({ name: 'ethliquify', params: {}});
    },

    newValidatorDeposit() {
      this.$emit('newValidatorDeposit');
    },
    jumpToPoolDetail(item) {
      this.$emit('jumpToPoolDetail', item.address, item.status, 'status');
    },

    updateStatus() {
      if (this.pubKeys.length == this.poolCount) {
        let validPubKeys = [];
        this.pubKeys.forEach((pubkey) => {
          if (pubkey) {
            validPubKeys.push(pubkey);
          }
        });
        if (validPubKeys.length == 0) {
          this.addressItems.forEach((item) => {
            item.status = 7;
          });
          return;
        }
        Rpc.fetchStakingPoolList({pubkeyList: JSON.stringify(validPubKeys)}).then(result => {
          if (result.status == '80000') {
            if (result.data) {
              let totalStakeAmount = 0;
              if (result.data.allStakeAmount) {
                totalStakeAmount = result.data.allStakeAmount;
              }
              if (result.data.apr) {
                this.currentApr = result.data.apr + '%';
              }
              if (result.data.list) {

                let remoteDataItems = result.data.list;

                let map = new Map();
                remoteDataItems.forEach((remoteItem) => {
                  if (remoteItem.pubkey) {
                    map.set(this.pubKeyMap.get(remoteItem.pubkey), remoteItem);
                    if (remoteItem.status == 7) {
                      totalStakeAmount = Number(totalStakeAmount) + 32;
                    }
                  }
                });

                this.addressItems.forEach((item) => {
                  let key = item.address.toLowerCase();
                  if (map.has(key)) {
                    item.status = map.get(key).status == 7 ? 2 : map.get(key).status; 
                  } else {
                    item.status = 7;
                  }
                });
              }

              if (totalStakeAmount > 0) {
                let count = 0;
                let totalCount = 10;
                let ratioAmount = 0;
                let piece = totalStakeAmount / totalCount;
                let interval = setInterval(() => {
                  count++;
                  ratioAmount += piece;
                  if (count == totalCount) {
                    ratioAmount = totalStakeAmount;
                    window.clearInterval(interval);
                  }
                  this.totalStakedETHShow = NumberUtil.handleEthGweiToFixed(ratioAmount);
                }, 100);
              }
              
            }
          } 
        });

      }
    }
  },

  created() {
    if (ethereum.selectedAddress) {
      let address = ethereum.selectedAddress;
      // let address = '0x497B41ce07248b61Af71f58FEd4e07257767Bb80';
      // let address = '0xf1e18080ebbe9cb23395ae0c811ecde35fc2ca3c';
      let web3 = Web3Util.getWeb3();
      let contract = new web3.eth.Contract(Web3Util.getStafiStakingPoolManagerAbi(), Web3Util.getStafiStakingPoolManagerAddress(), {
        from: address
      });

      contract.methods.getNodeStakingPoolCount(address).call().then(poolCount => {
        if (poolCount > 0) {
          this.poolCount = poolCount;

          for (let index = 0; index < poolCount; index++) {
            contract.methods.getNodeStakingPoolAt(address, index).call().then(poolAddress => {
              let item = {
                address: poolAddress,
                shortAddress: StringUtil.replacePkh(poolAddress, 4, 38),
                status: -1
              }
              this.addressItems.push(item);

              let pubKey = LocalStorage.getPoolPubKey(poolAddress);
              if (pubKey) {
                // this.liquefyBtnActiveStatus = 1;
                this.pubKeys.push(pubKey);
                this.pubKeyMap.set(pubKey, poolAddress.toLowerCase());
                this.updateStatus();
              } else {
                contract.methods.getStakingPoolPubkey(poolAddress).call().then(pubkey => {
                  if (pubkey) {
                    // this.liquefyBtnActiveStatus = 1;
                    this.pubKeys.push(pubKey);
                    this.pubKeyMap.set(pubKey, poolAddress.toLowerCase());
                    LocalStorage.setPoolPubKey(poolAddress, pubkey);
                  } else {
                    this.pubKeys.push('');
                  }
                  this.updateStatus();
                });
              }

              let poolContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolAbi(), poolAddress, {
                from: address
              });

              poolContract.methods.getStatus().call().then(status => {
                if (status == 4) {
                  this.addressItems.some((item) => {
                    if (item.address.toLowerCase() == poolAddress.toLowerCase()) {
                      item.status = 8; 
                      return true;
                    }
                  });
                }
              });

              poolContract.methods.getNodeDepositBalance().call().then(depositBalance => {
                let parsedDepositBalance = parseFloat(web3.utils.fromWei(depositBalance, 'ether'));
                this.selfDeposited += parsedDepositBalance;
                this.selfDepositedShow = NumberUtil.handleEthRoundToFixed(this.selfDeposited);
              });
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">

.validator-status {

  .overview {
    padding-bottom: 35px;
    border-bottom: 1px solid #474747;
  } 

  .head {
    display: flex;
    .icon {
      margin-top: 36px;
      margin-right: 10px;
      height: 36px;
      img {
        height: 100%;
      }
    }
  }

  .stake-info {
    display: flex;
    margin-left: 55px;
    margin-top: 20px;

    .amount {
      font-size: 30px;
      font-weight: bold;
      color: #00F3AB;
    }

    .btn {
      cursor: pointer;
      margin-left: 190px;
      width: 69px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #23292F;
      font-weight: bold;
      background-color: #00F3AB;
      border-radius: 13px;
      text-align: center;
      opacity: 0.4;
    }

    .btn-active {
      opacity: 1;
    }
    
  }

  .amount-detail {
    width: 145px;
    margin-top: 30px;
    margin-left: 60px;
    font-size: 12px;

    .self-amount {
      padding-bottom: 10px;
      border-bottom: 1px solid #474747;
      padding-left: 2px;
      padding-right: 24px;
    }
    .apr {
      margin-top: 10px;
      padding-left: 2px;
    }

    .bold {
      font-weight: bold;
    }
  }

  .contract {
    margin-top: 30px;

    .contract-head {
      display: flex;
      padding-left: 10px;
      margin-bottom: 20px;

      .contract-title {
        margin-right: 10px;
        font-weight: bold;
        font-size: 30px;
      }
    }

    .contract-items {

      .contract-item {
        padding-left: 10px;
        padding-right: 42px;
        margin-top: 10px;
        font-size: 12px;
        padding-bottom: 10px;
        border-bottom: 1px solid #474747;

        display: flex;

        .address-desc {
          margin-right: 10px;
        }

        .address {
          cursor: pointer;
          color: #00F3AB;
          font-weight: bold;
          text-decoration: underline;
          width: 320px;
        }

        .address-status {
          font-weight: bold;
        }
      }
    }
    
  }

  .deposit-btn {
    cursor: pointer;
    margin-left: 361px;
    width: 95px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    border-radius: 13px;
    text-align: center;
    margin-top: 30px;
  }
}
  
</style>